import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import { connect } from "react-redux";
import CancellationValue from "./cancellation-value";

class Cancellation extends Component {
  createMarkup(string) {
    return { __html: string };
  }

  render() {
    const { productDetails } = this.props;
    let cancellation = CancellationValue(productDetails);
    return (
      <Table attached>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign="center">
              PROJECT CANCELLATION
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <span
                dangerouslySetInnerHTML={this.createMarkup(cancellation)}
              ></span>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    productDetails: state.feProductDetails
  };
};

export default connect(mapStateToProps, null)(Cancellation);
